<div class="saved-steps-viewer">

  <div class="col left">
    <div class="panel-heading">Saved Steps</div>

    <div class="state-message" *ngIf="isLoading">
      <span class="spinner-sm"></span> Loading…
    </div>

    <div class="state-message error" *ngIf="!isLoading && loadError">
      {{ loadError }}
      <button class="btn-text" (click)="loadSteps()">Retry</button>
    </div>

    <div class="state-message" *ngIf="!isLoading && !loadError && steps.length === 0">
      No saved steps yet — check "Save Steps" while recording to see steps here.
    </div>

    <div class="step-list" *ngIf="!isLoading && !loadError && steps.length > 0">
      <div
        class="step-row"
        *ngFor="let step of steps"
        [class.step-row--selected]="selectedStepId === step['_id']">
        <span class="step-clickzone" (click)="selectStep(step)">
          <span class="step-name">{{ step.name }}</span>
          <span class="step-count">{{ step.commandSteps?.length || 0 }}</span>
        </span>

        <div class="row-menu" [class.row-menu--open]="isMenuOpen(step)">
          <button class="row-menu-trigger" (click)="toggleMenu(step, $event)">
            <span class="material-symbols-outlined">more_vert</span>
          </button>
          <div class="row-menu-dropdown" *ngIf="isMenuOpen(step)" (click)="$event.stopPropagation()">
            <button (click)="onMenuDelete(step)">Delete Step</button>
            <button (click)="onMenuCopy(step)">Copy Step</button>
            <button (click)="onMenuRename(step)">Rename Step</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col right">
    <div class="step-detail-toolbar" *ngIf="selectedStepId">
      <div class="switch-row">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="showEnglishDescription">
          <span class="switch-slider"></span>
        </label>
        <span>English Description</span>
      </div>
      <button class="btn-primary" [disabled]="isPromoting" (click)="onSaveToCanvas()">
        {{ isPromoting ? 'Saving…' : 'Save to Canvas' }}
      </button>
    </div>

    <div class="command-list" *ngIf="selectedStepId">
      <div class="state-message" *ngIf="isLoadingCommands">
        <span class="spinner-sm"></span> Loading…
      </div>
      <div class="state-message" *ngIf="!isLoadingCommands && selectedStepCommands.length === 0">
        No commands recorded in this step.
      </div>
      <div class="command-row" *ngFor="let c of selectedStepCommands">
        <ng-container *ngIf="showEnglishDescription && c.english_description; else defaultRow">
          <div class="cmd-english">{{ c.english_description }}</div>
          <button class="row-settings" *ngIf="c.target" title="Element details" (click)="onOpenElementDetails(c, $event)">
            <span class="material-symbols-outlined">settings</span>
          </button>
        </ng-container>
        <ng-template #defaultRow>
          <span class="cmd-pill">{{ c.command?.name }}</span>
          <ng-container *ngIf="c.target">
            <div class="cmd-target">{{ c.target?.name || c.target?.xpath || '' }}</div>
            <button class="row-settings" title="Element details" (click)="onOpenElementDetails(c, $event)">
              <span class="material-symbols-outlined">settings</span>
            </button>
          </ng-container>
          <div class="cmd-value" *ngIf="c.value">{{ c.value }}</div>
        </ng-template>
      </div>
    </div>

    <div class="placeholder" *ngIf="!selectedStepId">
      Select a step on the left to view its recorded commands.
    </div>
  </div>

</div>

<div class="toast-container">
  <div class="toast toast--success" *ngIf="toastMessage && toastType === 'success'">{{ toastMessage }}</div>
  <div class="toast toast--error" *ngIf="toastMessage && toastType === 'error'">{{ toastMessage }}</div>
</div>
